import axios from 'axios';
import apiConfig from '../api.config';

export default function pmsHotelsRequest() {
  const {
    host,
    URIs: { pmsHotels },
  } = apiConfig;

  const uri = `${host}${pmsHotels}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
